export default "__VITE_ASSET__D3TZc7ma__"